module.exports = __webpack_public_path__ + "img/snapshot.a40deac.svg";